import React from 'react';
import { Star } from 'lucide-react';
import type { UserPet } from '../../types/pets';

interface PetSelectionProps {
  pets: UserPet[];
  selectedPets: UserPet[];
  onSelect: (pets: UserPet[]) => void;
  maxSelections: number;
}

export function PetSelection({ pets, selectedPets, onSelect, maxSelections }: PetSelectionProps) {
  const handleSelect = (pet: UserPet) => {
    if (selectedPets.includes(pet)) {
      onSelect(selectedPets.filter(p => p !== pet));
    } else if (selectedPets.length < maxSelections) {
      onSelect([...selectedPets, pet]);
    }
  };

  const rarityColors = {
    common: 'text-gray-400',
    uncommon: 'text-green-400',
    rare: 'text-blue-400',
    epic: 'text-purple-400',
    legendary: 'text-yellow-400'
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      {pets.map((pet) => (
        <button
          key={pet.id}
          onClick={() => handleSelect(pet)}
          className={`p-4 rounded-lg text-left transition-all ${
            selectedPets.includes(pet)
              ? 'bg-gradient-to-r from-yellow-600 to-amber-500'
              : 'bg-gray-800 hover:bg-gray-750'
          }`}
        >
          <div className="flex items-center gap-3">
            <img
              src={pet.imageUrl}
              alt={pet.name}
              className="w-12 h-12 rounded-lg object-cover"
            />
            <div>
              <div className="flex items-center gap-2">
                <span className="font-medium text-white">{pet.name}</span>
                <Star className={`w-4 h-4 ${rarityColors[pet.rarity]}`} />
              </div>
              <div className="text-sm text-gray-400">
                Level {pet.level} {pet.type}
              </div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}